const T_COMPARATOR_EQUALS = 'T_COMPARATOR_EQUALS';
const T_COMPARATOR_NOT_EQUALS = 'T_COMPARATOR_NOT_EQUALS';
const T_COMPARATOR_IN = 'T_COMPARATOR_IN';
const T_COMPARATOR_NOT_IN = 'T_COMPARATOR_NOT_IN';
const T_COMPARATOR_GREATER_THAN = 'T_COMPARATOR_GREATER_THAN';
const T_COMPARATOR_GREATER_THAN_OR_EQUAL = 'T_COMPARATOR_GREATER_THAN_OR_EQUAL';
const T_COMPARATOR_LESS_THAN = 'T_COMPARATOR_LESS_THAN';
const T_COMPARATOR_LESS_THAN_OR_EQUAL = 'T_COMPARATOR_LESS_THAN_OR_EQUAL';
const T_NUMBER = 'T_NUMBER';
const T_IDENTIFIER = 'T_IDENTIFIER';
const T_LOGIC_OR = 'T_LOGIC_OR';
const T_LOGIC_AND = 'T_LOGIC_AND';
const T_STRING_LITERAL = 'T_STRING_LITERAL';
const T_ARRAY = 'T_ARRAY';
const T_PARENTHESIS_OPEN = 'T_PARENTHESIS_OPEN';
const T_PARENTHESIS_CLOSE = 'T_PARENTHESIS_CLOSE';
const T_BRACKET_OPEN = 'T_BRACKET_OPEN';
const T_BRACKET_CLOSE = 'T_BRACKET_CLOSE';
const T_SEPARATOR_COMMA = 'T_SEPARATOR_COMMA';
const T_NULL = 'T_NULL';
const T_BOOL_TRUE = 'T_BOOL_TRUE';
const T_BOOL_FALSE = 'T_BOOL_FALSE';

const T_LOGIC_GROUP = [
    T_LOGIC_AND,
    T_LOGIC_OR,
];

const T_BOOL_GROUP = [
    T_BOOL_TRUE,
    T_BOOL_FALSE,
];

const T_IDENTIFIER_GROUP = [
    T_IDENTIFIER,
    T_STRING_LITERAL,
    T_NUMBER,
    T_ARRAY,
    T_NULL,
    T_BOOL_TRUE,
    T_BOOL_FALSE,
];

const T_COMPARATOR_GROUP = [
    T_COMPARATOR_EQUALS,
    T_COMPARATOR_NOT_EQUALS,
    T_COMPARATOR_IN,
    T_COMPARATOR_NOT_IN,
    T_COMPARATOR_GREATER_THAN,
    T_COMPARATOR_GREATER_THAN_OR_EQUAL,
    T_COMPARATOR_LESS_THAN,
    T_COMPARATOR_LESS_THAN_OR_EQUAL,
];

const T_BRACKET_GROUP = [
    T_BRACKET_OPEN,
    T_SEPARATOR_COMMA,
    T_BRACKET_CLOSE,
    ...T_IDENTIFIER_GROUP
];


const TOKEN_MATCHING = {
    [T_NUMBER]: /^-*\d+(.\d+)*$/,
    [T_STRING_LITERAL]: /^'.*?'$/,
    [T_COMPARATOR_EQUALS]: /^(==|EQ)$/,
    [T_COMPARATOR_NOT_EQUALS]: /^(!=|!EQ|≠)$/,
    [T_COMPARATOR_IN]: /^(IN)$/,
    [T_COMPARATOR_NOT_IN]: /^(!IN)$/,
    [T_COMPARATOR_GREATER_THAN]: /^(>)$/,
    [T_COMPARATOR_GREATER_THAN_OR_EQUAL]: /^(>=|≥)$/,
    [T_COMPARATOR_LESS_THAN]: /^(<)$/,
    [T_COMPARATOR_LESS_THAN_OR_EQUAL]: /^(<=|≤)$/,
    [T_LOGIC_AND]: /^(AND)$/,
    [T_LOGIC_OR]: /^(OR)$/,
    [T_PARENTHESIS_OPEN]: /^(\()$/,
    [T_PARENTHESIS_CLOSE]: /^(.*?)(\))$/,
    [T_BRACKET_OPEN]: /^(\[)$/,
    [T_BRACKET_CLOSE]: /^(.*?)(])$/,
    [T_SEPARATOR_COMMA]: /^([^,]*)(,)$/,
    [T_NULL]: /^(NULL)$/i,
    [T_BOOL_TRUE]: /^(TRUE)$/i,
    [T_BOOL_FALSE]: /^(FALSE)$/i,
};

const TOKEN_SEPARATOR = [' ', ',', '(', ')', '[', ']', '|', '==', '!=', '>', '>=', '<', '<=', '≤', '≥', '≠'];

const tokenizer = (condition) => {
    const tokens = [];
    let token = '';
    let isStringLiteral = false;
    let isEscape = false;
    let char;
    const len = condition.length;
    for (let i = 0; i < len; i++) {
        char = condition[i];
        if (char === '\\') {
            isEscape = true;
            continue;
        }
        if (isEscape) {
            token += char;
            isEscape = false;
            continue;
        }
        if (isStringLiteral) {
            token += char;
        }
        if (char === '\'') {
            if (isStringLiteral) {
                tokens.push(token);
                token = '';
            } else {
                if (token) {
                    tokens.push(token);
                }
                token = char;
            }
            isStringLiteral = !isStringLiteral;
            continue;
        }
        if (!isStringLiteral) {
            token += char;
            for (let separator of TOKEN_SEPARATOR) {
                if (separator === token.substring(token.length - separator.length)) {
                    let currentToken = token.substring(0, token.length - separator.length).trim();
                    if (currentToken) {
                        tokens.push(currentToken);
                    }
                    let currentSeparator = token.substring(token.length - separator.length).trim();
                    if (currentSeparator) {
                        if (TOKEN_SEPARATOR.includes(currentSeparator + condition[i + 1])) {
                            tokens.push(currentSeparator + condition[i + 1]);
                            i++
                        } else {
                            tokens.push(currentSeparator);
                        }
                    }
                    token = '';
                }
            }
        }
    }
    if (token) {
        tokens.push(token);
    }
    return tokens;
};


class Token {
    constructor(type, value) {
        this.type = type;
        this.value = value;
    }
}

const lexer = (condition) => {
    const tokens = [];
    let matches;
    let isMatched = false;

    for (let token of tokenizer(condition)) {
        isMatched = false;
        for (let type in TOKEN_MATCHING) {
            matches = token.match(TOKEN_MATCHING[type]);
            if (matches) {
                tokens.push(new Token(type, token));
                isMatched = true;
                break;
            }
        }
        if (!isMatched) {
            tokens.push(new Token(T_IDENTIFIER, token));
        }
    }
    return tokens;
};

const evaluateIdentifier = (identifier, data) => {
    if (!(identifier instanceof Token)) {
        identifier = wrapIdentifier(identifier);
    }

    if (identifier.type === T_NULL || identifier.value === undefined || identifier.value === null) {
        return null;
    }

    if (identifier.value === true || identifier.type === T_BOOL_TRUE) {
        return true;
    }

    if (identifier.value === false || identifier.type === T_BOOL_FALSE) {
        return false;
    }

    if (identifier.type === T_IDENTIFIER && (identifier.value[0] === '@' || identifier.value[0] === '$')) {
        if (identifier.value.indexOf('.') !== -1) {
            const path = identifier.value.split('.');
            const first = path.shift();
            let currentValue = data[first.substring(1)];
            for (let item of path) {
                if (item[0] === '@' || item[0] === '$') {
                    item = evaluateIdentifier(new Token(T_IDENTIFIER, item), data);
                }
                currentValue = currentValue[item];
            }
            return currentValue;
        }
        return data[identifier.value.substring(1)];
    }

    if (identifier.type === T_STRING_LITERAL) {
        return identifier.value.substring(1, identifier.value.length - 1);
    }

    return identifier.value;
};

const wrapIdentifier = (value) => {
    if (value === true) {
        return new Token(T_BOOL_TRUE, value);
    }
    if (value === false) {
        return new Token(T_BOOL_FALSE, value);
    }
    if (value === null || value === undefined || isNaN(value)) {
        return new Token(T_NULL, null);
    }
    if (typeof value === 'number') {
        return new Token(T_NUMBER, value);
    }
    if (Array.isArray(value)) {
        return new Token(T_ARRAY, value);
    }
    return new Token(T_IDENTIFIER, value);
};

const CACHED_CONDITIONS = {};
const getCachedOrParseLogicCondition = (conditionString) => {
    if (!CACHED_CONDITIONS[conditionString]) {
        CACHED_CONDITIONS[conditionString] = lexer(conditionString);
    }
    return CACHED_CONDITIONS[conditionString];
};

const evaluateLogicExpression = (left, comparator, right) => {
    let leftValue = left instanceof Token ? left.value : left;
    let rightValue = right instanceof Token ? right.value : right;

    switch (comparator.type) {
        case T_COMPARATOR_EQUALS:
            return leftValue == rightValue;

        case T_COMPARATOR_NOT_EQUALS:
            return leftValue != rightValue;

        case T_COMPARATOR_IN:
            if (rightValue && rightValue[Symbol.iterator] && rightValue.length > 0) {
                for (let val of rightValue) {
                    if (val == leftValue) {
                        return true;
                    }
                }
            }
            return false

        case T_COMPARATOR_NOT_IN:
            if (rightValue && rightValue[Symbol.iterator] && rightValue.length > 0) {
                for (let val of rightValue) {
                    if (val == leftValue) {
                        return false;
                    }
                }
            }
            return true;

        case T_COMPARATOR_GREATER_THAN:
            return leftValue > rightValue;

        case T_COMPARATOR_GREATER_THAN_OR_EQUAL:
            return leftValue >= rightValue;

        case T_COMPARATOR_LESS_THAN:
            return leftValue < rightValue;

        case T_COMPARATOR_LESS_THAN_OR_EQUAL:
            return leftValue <= rightValue;
    }
    throw `Invalid comparator: ${comparator[1]}`;
};

const evaluateBracket = (bracket, data) => {
    const value = [];
    const stack = [];
    let current = undefined;
    for (let token of bracket) {
        switch (token.type) {
            case T_SEPARATOR_COMMA:
                break;

            case T_BRACKET_OPEN:
                if (!current) {
                    current = value;
                } else {
                    const next = [];
                    current.push(next);
                    stack.push(current);
                    current = next;
                }
                break;

            case T_BRACKET_CLOSE:
                current = stack.pop();
                break;

            default:
                current.push(evaluateIdentifier(token, data));
        }
    }
    return value;
};

const isLogicExpression = (expression) => {
    return expression.length >= 3 &&
        T_IDENTIFIER_GROUP.includes(expression[0].type) &&
        T_COMPARATOR_GROUP.includes(expression[1].type) &&
        T_IDENTIFIER_GROUP.includes(expression[2].type);
}

export function evaluateLogicCondition(condition, data) {
    if (typeof condition === 'string') {
        condition = getCachedOrParseLogicCondition(condition);
    }

    let currentValue = undefined;
    let expression = [];
    let currentExpression = [];
    let currentParenthesis = [];
    let parenthesisCount = 0;
    let currentBracket = [];
    let bracketCount = 0;
    let expectNext;

    for (let token of condition) {
        if (expectNext && !expectNext.includes(token.type)) {
            throw `Parse error: Unexpected token ${token.type} "${token.value}". Expected ${expectNext.join(', ')}`;
        }

        // Parenthesis (...)
        if (parenthesisCount > 0) {
            currentParenthesis.push(token);
            if (token.type === T_PARENTHESIS_OPEN) {
                parenthesisCount++;
            }
            if (token.type === T_PARENTHESIS_CLOSE) {
                parenthesisCount--;
            }
            if (parenthesisCount === 0) {
                expression.push(wrapIdentifier(evaluateLogicCondition(currentParenthesis.slice(1, -1), data)));
                currentParenthesis = [];
            }
            continue;
        }

        // Bracket [...]
        if (bracketCount > 0) {
            if (!T_BRACKET_GROUP.includes(token.type)) {
                throw `Parse error: Unexpected token ${token.type} "${token.value}". Expected ${T_BRACKET_GROUP.join(', ')}`;
            }

            if (T_IDENTIFIER_GROUP.includes(token.type)) {
                expectNext = [T_SEPARATOR_COMMA, T_BRACKET_CLOSE];
            }

            if (token.type === T_SEPARATOR_COMMA) {
                expectNext = [
                    ...T_IDENTIFIER_GROUP,
                    T_BRACKET_OPEN,
                ];
            }

            if (token.type === T_BRACKET_OPEN) {
                bracketCount++;
                expectNext = [
                    ...T_IDENTIFIER_GROUP,
                    T_BRACKET_OPEN,
                    T_BRACKET_CLOSE,
                ];
            }

            currentBracket.push(token);
            if (token.type === T_BRACKET_CLOSE) {
                bracketCount--;
            }

            if (bracketCount === 0) {
                currentExpression.push(wrapIdentifier(evaluateBracket(currentBracket, data)));
                currentBracket = [];
                expectNext = null;
            }
            continue;
        }

        // Start parenthesis
        if (token.type === T_PARENTHESIS_OPEN) {
            currentParenthesis.push(token);
            parenthesisCount++;
            expectNext = null;
            continue;
        }

        // Stat bracket
        if (token.type === T_BRACKET_OPEN) {
            currentBracket.push(token);
            bracketCount++;
            continue;
        }

        // Evaluate logic expression
        if (isLogicExpression(currentExpression)) {
            expression.push(wrapIdentifier(evaluateLogicExpression(
                evaluateIdentifier(currentExpression[0], data),
                currentExpression[1],
                evaluateIdentifier(currentExpression[2], data),
            )));
            currentExpression = currentExpression.slice(3);
        }

        if (T_IDENTIFIER_GROUP.includes(token.type)) {
            currentExpression.push(token);
            if (currentExpression.length === 1) {
                expectNext = T_COMPARATOR_GROUP;
            } else {
                expectNext = null;
            }
            continue;
        }

        if (T_COMPARATOR_GROUP.includes(token.type)) {
            currentExpression.push(token);
            expectNext = [
                ...T_IDENTIFIER_GROUP,
                T_BRACKET_OPEN,
            ];
            continue;
        }

        if (T_LOGIC_GROUP.includes(token.type)) {
            expression.push(token);
            currentExpression.splice(1);
            expectNext = [
                ...T_IDENTIFIER_GROUP,
                T_BRACKET_OPEN,
                T_PARENTHESIS_OPEN,
            ];
            continue;
        }

        throw `Parse error: Unexpected token ${token.type} "${token.value}"`;
    }

    if (currentExpression.length === 1 && T_BOOL_GROUP.includes(currentExpression[0].type)) {
        expression.push(wrapIdentifier(evaluateIdentifier(currentExpression[0])));
        currentExpression = [];
    }

    if (currentExpression.length > 0 && isLogicExpression(currentExpression)) {
        expression.push(wrapIdentifier(evaluateLogicExpression(
            evaluateIdentifier(currentExpression[0], data),
            currentExpression[1],
            evaluateIdentifier(currentExpression[2], data),
        )));
    }

    let currentOperation = undefined;
    for (let token of expression) {
        if (T_LOGIC_GROUP.includes(token.type)) {
            currentOperation = token
        } else if (T_BOOL_GROUP.includes(token.type)) {
            if (currentValue === undefined) {
                currentValue = token.value;
            } else {
                if (currentOperation.type === T_LOGIC_AND) {
                    currentValue = currentValue && token.value;
                    currentOperation = undefined;
                } else if (currentOperation.type === T_LOGIC_OR) {
                    currentValue = currentValue || token.value;
                    currentOperation = undefined;
                } else {
                    throw `Parse error: Unexpected token ${token.type} "${token.value}". Expected ${T_LOGIC_GROUP.join(', ')}`;
                }
            }
        } else {
            throw `Parse error: Unexpected token ${token.type} "${token.value}". Expected ${[...T_LOGIC_GROUP, ...T_BOOL_GROUP].join(', ')}`;
        }
    }
    return currentValue
}
